import React from 'react'

import { selectCategory } from '../../../../dashboard'

import style from './CheckButton.module.css'

import { Button } from 'common/components'
import { useAppDispatch, useAppSelector, useKeyDown } from 'common/hooks'
import { Task } from 'data/categories'
import { checkCode, selectTimerStatus } from 'features/simulator/index'

type PropsType = {
  task: Task
  codeLines: string[]
}

export const CheckButton = ({ task, codeLines }: PropsType) => {
  const dispatch = useAppDispatch()
  const status = useAppSelector(selectTimerStatus)
  const category = useAppSelector(state => selectCategory(state, task.categoryId))

  const checkTask = () => {
    dispatch(checkCode(codeLines))
  }

  useKeyDown(checkTask, 'Enter', true)

  return (
    <div className={style.box}>
      {category?.activities.attempts === 0 && <span className={style.hint}>(Alt + Enter)</span>}
      <Button
        onClick={checkTask}
        accent
        className={style['check-button']}
        title="Alt + Enter"
        disabled={status !== 'active'}
      >
        Проверить
      </Button>
    </div>
  )
}
